/**
 * React Query keys for the member-facing Resources surfaces.
 *
 * `all` is the invalidation root. Keys are parameterised where the backend
 * returns different data per identifier (folder slug, item id).
 */
export const resourcesKeys = {
  all: ['resources'] as const,
  items: () => [...resourcesKeys.all, 'items'] as const,
  item: (id: string) => [...resourcesKeys.items(), id] as const,
  /** The landing page's featured card — its own key, since it fetches one row. */
  featuredItem: () => [...resourcesKeys.items(), 'featured'] as const,
  /** The dashboard's newest-items preview (MYN-254). */
  latestItems: (limit: number) => [...resourcesKeys.items(), 'latest', limit] as const,
  folders: () => [...resourcesKeys.all, 'folders'] as const,
  folder: (slug: string) => [...resourcesKeys.folders(), slug] as const,
};
